<template>
    <div>
        <page-title>编辑站点信息</page-title>
        <page-body>
            <el-form v-loading="loading" :model="form" :rules="rules" ref="form">
                <el-form-item label="站点名称" prop="name">
                    <el-input v-model="form.name"/>
                </el-form-item>
                <el-form-item label="协议" prop="protocol">
                    <div style="color: #F56C6C">重要: 请确认您的站点是否支持相关协议，否则云服务无法正常使用。如果您开启了强制https请选择 https://</div>
                    <el-radio-group v-model="form.protocol">
                        <el-radio-button label="https://">https://</el-radio-button>
                        <el-radio-button label="http://">http://</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="域名" prop="domain">
                    <el-input v-model="form.domain"/>
                </el-form-item>
                <el-form-item label="服务器IP" prop="host_ip_list">
                    <el-button type="text" @click="addHostIp"><i class="el-icon-plus"></i>添加IP</el-button>
                    <div>
                        <el-form-item class="host-ip-row" v-for="(item, index) in form.host_ip_list" :key="index.key"
                                      :prop="'host_ip_list.' + index + '.ip'"
                                      :rules="[{required: true, message: '请填写服务器IP。'}, {validator: validateIp, trigger: 'blur'}]">
                            <div flex="dir:left box:last" style="width: 100%">
                                <div style="padding-right: 10px">
                                    <el-input v-model="item.ip"/>
                                </div>
                                <div>
                                    <el-button type="danger" plain @click.prevent="removeHostIp(item)">删除</el-button>
                                </div>
                            </div>
                        </el-form-item>
                    </div>
                </el-form-item>
                <el-form-item label="授权版本" prop="type">
                    <br>
                    <el-select v-model="form.type" placeholder="选择版本">
                        <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="子账户数量" prop="account_num"
                              :style="'display: ' + (form.type === 2 ? 'block' : 'none')">
                    <div style="color: #909090">填写<span>-1</span>表示不限制子账户数量</div>
                    <el-input v-model="form.account_num"/>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" @click="submit('form')" type="primary">{{form.id ? '保存' : '添加站点'}}
                    </el-button>
                </el-form-item>
            </el-form>
        </page-body>
    </div>
</template>

<style scoped>
.host-ip-row {
    margin-top: 25px;
}

.host-ip-row:first-child {
    margin-top: 0;
}
</style>

<script>
import axios from '@/axios'

export default {
    data() {
        const validateAccountNum = (rule, value, callback) => {
            if (this.form.type !== 2) {
                return callback()
            }
            value = parseInt(value)
            if (isNaN(value)) {
                return callback(new Error('子账户数量必须是数字。'))
            }
            if (value === null || value === '') {
                return callback(new Error('请填写子账户数量。'))
            }
            if (value < -1) {
                return callback(new Error('请填写子账户数量必须等于大于0。'))
            }
            this.form.account_num = value
            return callback()
        }
        return {
            loading: false,
            btnLoading: false,
            detail: null,
            typeOptions: [
                {
                    value: 1,
                    label: '微擎版'
                },
                {
                    value: 2,
                    label: '独立版'
                }
            ],
            rules: {
                name: [
                    {required: true, message: '请填写站点名称。'}
                ],
                protocol: [
                    {required: true, message: '请填写选择站点传输协议。'}
                ],
                domain: [
                    {required: true, message: '请填写域名。'}
                ],
                host_ip_list: [
                    {required: true, message: '请填写服务器IP。'}
                ],
                type: [
                    {required: true, message: '请选择版本。'}
                ],
                account_num: [
                    {validator: validateAccountNum}
                ]
            },
            form: {
                id: null,
                name: '',
                protocol: 'https://',
                domain: '',
                host_ip_list: [{
                    ip: ''
                }],
                status: 0,
                type: null,
                account_num: 0
            }
        }
    },
    created() {
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id
            this.loadData()
        }
    },
    methods: {
        validateIp(rule, value, callback) {
            if (!value) {
                callback()
            } else {
                const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
                if (!reg.test(value)) {
                    callback(new Error('IP格式不正确。'))
                } else {
                    callback()
                }
            }
        },
        loadData() {
            this.loading = true
            axios({
                url: 'admin/host/detail',
                params: {
                    id: this.form.id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.detail = e.data.data
                    this.form.name = e.data.data.name
                    this.form.protocol = e.data.data.protocol
                    this.form.domain = e.data.data.domain
                    this.form.host_ip_list = e.data.data.hostIps
                    this.form.status = e.data.data.status
                    this.form.type = e.data.data.type
                    this.form.account_num = e.data.data.account_num
                }
            })
        },
        removeHostIp(item) {
            let index = this.form.host_ip_list.indexOf(item)
            if (index !== -1) {
                this.form.host_ip_list.splice(index, 1)
            }
        },
        addHostIp() {
            this.form.host_ip_list.push({
                value: '',
                key: Date.now()
            })
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    axios({
                        url: 'admin/host/update',
                        params: {
                            id: this.form.id
                        },
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.btnLoading = false
                        if (e.data.code === 0) {
                            this.$message.success('保存成功。')
                            this.$router.replace('/dashboard/admin/host/index')
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                }
            })
        }
    }
}
</script>
